import React from 'react';
import Pageheader from '../../../utils/headerHelment';
import { useStandardOverviewData } from '../../../hooks/useStandardOverviewData';
import OverviewHeader from './OverviewHeader';
import WorkstreamsSetupCard from './WorkstreamsSetupCard';
import InformationRequestsCard from './InformationRequestsCard';
import VDRCard from './VDRCard';
import ObservationsCard from './ObservationsCard';
import SourceMaterialsCard from './SourceMaterialsCard';
import IntelligenceInsightsCard from './IntelligenceInsightsCard';
import SwotCard from './SwotCard';
import IndexScoresCard from './IndexScoresCard';
import DeliveryGovernanceCard from './DeliveryGovernanceCard';
import ProjectKnowledgeCard from './ProjectKnowledgeCard';
import RecentProjectActivityCard from './RecentProjectActivityCard';
import SinceLastVisitBanner from './SinceLastVisitBanner';
import ProjectAttentionCard from './ProjectAttentionCard';
import styles from './StandardOverview.module.css';

const StandardOverview = () => {
    const model = useStandardOverviewData();

    return (
        <>
            <Pageheader title="LENS - Overview" />
            <div className={styles.page}>
                <div className={styles.pageInner}>
                    <OverviewHeader model={model} />

                    {!model.hasWorkstreams ? (
                        <section className={styles.section}>
                            <WorkstreamsSetupCard />
                        </section>
                    ) : null}

                    {model.showSinceLastVisit ? (
                        <section className={styles.sectionTight}>
                            <SinceLastVisitBanner data={model.sinceLastVisit} />
                        </section>
                    ) : null}

                    {model.showProjectAttention ? (
                        <section className={styles.sectionTight}>
                            <ProjectAttentionCard attention={model.projectAttention} />
                        </section>
                    ) : null}

                    {model.features.informationRequests || model.features.dataroom || model.features.observations ? (
                        <section className={styles.section}>
                            <div className={styles.primaryRow}>
                                {model.features.informationRequests ? (
                                    <InformationRequestsCard model={model} />
                                ) : null}
                                {model.features.dataroom ? (
                                    <VDRCard model={model} highlight={model.highlight === 'vdr'} />
                                ) : null}
                                {model.features.observations ? <ObservationsCard model={model} /> : null}
                            </div>
                        </section>
                    ) : null}

                    {model.showInsightsSections ? (
                        <section className={styles.sectionTight}>
                            <div className={styles.secondaryRow}>
                                {model.features.lensIntelligence ? (
                                    <IntelligenceInsightsCard model={model} />
                                ) : null}
                                {model.features.swot ? <SwotCard model={model} /> : null}
                                {model.features.indexScores ? <IndexScoresCard model={model} /> : null}
                            </div>
                        </section>
                    ) : null}

                    {model.showDeliveryKnowledgeSections ? (
                        <section className={styles.sectionTight}>
                            <div className={styles.bottomRow}>
                                {model.features.deliveryGovernance ? (
                                    <DeliveryGovernanceCard model={model} />
                                ) : null}
                                {model.features.projectKnowledge ? (
                                    <ProjectKnowledgeCard model={model} />
                                ) : null}
                            </div>
                        </section>
                    ) : null}

                    {model.showRecentActivity ? (
                        <section className={styles.sectionTight}>
                            <RecentProjectActivityCard
                                items={model.recentActivity}
                                usesDummyData={model.usesMaturityDummyData || model.irlCard?.usesDummyData}
                            />
                        </section>
                    ) : null}

                    <section className={styles.sectionTight}>
                        <SourceMaterialsCard model={model} />
                    </section>
                </div>
            </div>
        </>
    );
};

export default StandardOverview;
